<template>
  <div v-if="popShow" class="pop_box" :style="{ zIndex: Z_INDEX_MODAL }">
    <div class="pop_container" :class="{ notice_box: btn === 'I got it' }">
      <img @click="Next('View Details')" v-show="msgImg" class="msg_img" :src="msgImg" alt="" />
      <div class="content_box">
        <div class="pop_title">{{ title }}</div>
        <div class="pop_content" v-html="content"></div>
        <slot></slot>
        <div class="footer">
          <div v-show="cancelShow" @click="Next(cancel)" class="pop_btn cancel_btn">
            {{ cancel }}
          </div>
          <div v-show="btnShow" @click="Next(btn)" class="pop_btn">{{ btn }}</div>
        </div>
        <div class="pop_tips">{{ tips }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Z_INDEX_MODAL } from '@/utils/constants'

export default {
  name: 'PopWindow',
  props: {
    title: {
      type: String
    },
    content: {
      type: String
    },
    btn: {
      type: String
    },
    tips: {
      type: String
    },
    cancel: {
      type: String,
      default: 'Cancel'
    },
    cancelShow: Boolean,
    msgImg: String,
    jumpLink: String,
    messageId: String,
    kycSuccessCase: Number
  },
  data() {
    return {
      Z_INDEX_MODAL,
      popShow: true,
      btnShow: false
    }
  },
  watch: {
    btn: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.btnShow = true
        } else {
          this.btnShow = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    Next(btn) {
      // TODO: 重构这部分代码，公共组件不应包含业务逻辑
      if ((this.cancelShow && this.cancel === 'OK') || btn === 'OK') {
        // 提现拉黑弹窗
        this.popShow = false
        this.$emit('closePop')
        this.readMsg(this.messageId, btn)
      } else {
        // 系统消息
        if (btn === this.$t('common.confirm')) {
          this.$emit('closePop')
          // 跳转一级验证
          this.$router.push({
            name: 'BasicLevel',
            query: { reWrite: true }
          })
        } else if (this.messageId) {
          this.readMsg(this.messageId, btn)
        } else if (btn === this.$t('home.goToSubmit')) {
          this.$emit('closePop')
          // kyc索取
          this.$router.push({
            name: 'DocumentDetails'
          })
        } else if (btn === "Don't remind me again") {
          // 公告消息不再提示
          this.$emit('readChangeNameNotice')
        } else if (btn === 'I got it') {
          this.popShow = false
          sessionStorage.setItem('isReadMsg', true)
        } else if (btn === this.$t('home.fillIn')) {
          this.$emit('closePop')
          // 一级验证修改
          this.$router.push({
            name: 'EditBasicUserInfo'
          })
        } else {
          this.$emit('ifKYC')
        }
      }
    },
    readMsg(messageId, btn) {
      let data = {
        userId: this.$store.state.userInfo.userId,
        messageId
      }
      this.$http
        .post(window.serverPath + '/api/user/system/message/read_message', data)
        .then((res) => {
          if (res.data && res.data.code === '200') {
            if (this.jumpLink && btn !== this.$t('common.cancel')) {
              window.location.href = this.jumpLink
            }
            this.$emit('getUnreadMsg')
          }
        })
        .catch((err) => console.log(err))
    }
  }
}
</script>

<style scoped>
.pop_box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.57);
}

.pop_container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - 0.48rem);
  font-size: 0.14rem;
  background: #fff;
  border-radius: 0.24rem;
  text-align: center;
  overflow: hidden;
  font-family: 'PingFang SC';
}

.notice_box {
  text-align: center;
}

.content_box {
  padding: 0.24rem;
  box-sizing: border-box;
}

.msg_img {
  width: 100%;
  max-height: 1.5rem;
}

.pop_title {
  color: #2f2f2f;
  font-weight: 600;
  font-size: 0.18rem;
  line-height: 0.26rem;
}

.pop_content {
  font-size: 0.16rem;
  color: #5b5b5b;
  margin: 0.12rem 0 0.24rem;
  line-height: 0.24rem;
  font-weight: 400;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.footer {
  display: flex;
  align-items: center;
}

.pop_btn {
  width: 100%;
  height: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 0.08rem;
  font-size: 0.16rem;
  background: linear-gradient(90deg, #43d77d 0%, #3fbb70 100%), rgba(0, 0, 0, 0.9);
}

.pop_btn.cancel_btn {
  margin-inline-end: 0.12rem;
  background: #fff;
  border: 0.01rem solid #3fbb70;
  color: #3fbb70;
}

.pop_tips {
  font-size: 0.12rem;
  color: red;
  text-align: center;
  margin-top: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/PopWindow.vue